import { render, staticRenderFns } from "./ShippingOrderPop.vue?vue&type=template&id=536dd1d5"
import script from "./ShippingOrderPop.vue?vue&type=script&lang=js"
export * from "./ShippingOrderPop.vue?vue&type=script&lang=js"
import style0 from "./ShippingOrderPop.vue?vue&type=style&index=0&id=536dd1d5&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536dd1d5')) {
      api.createRecord('536dd1d5', component.options)
    } else {
      api.reload('536dd1d5', component.options)
    }
    module.hot.accept("./ShippingOrderPop.vue?vue&type=template&id=536dd1d5", function () {
      api.rerender('536dd1d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/ShippingOrderPop.vue"
export default component.exports